import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative rounded-t-xl shadow-sm overflow-hidden hidden sm:block" }
const _hoisted_2 = { class: "block sm:hidden" }

import { ref, computed, watch } from "vue";
import { Dayjs } from "dayjs";
import i18n from "@/services/i18n";
import "dayjs/locale/vi";
import "dayjs/locale/en";
import localeVi from "ant-design-vue/es/date-picker/locale/vi_VN";
import localeEn from "ant-design-vue/es/date-picker/locale/en_US";
import { getLocale } from "@/utils/global";


export default /*@__PURE__*/_defineComponent({
  __name: 'DateRangePicker',
  emits: ["dateChange"],
  setup(__props, { emit: __emit }) {

const dateRange = ref<[Dayjs, Dayjs] | null>(null);
const mobileDateRange = ref<[Dayjs, Dayjs] | null>(null);
const isModalOpen = ref(false);

const currentLocale = computed(() =>
  getLocale() === "vi" ? localeVi : localeEn
);

const emit = __emit;

const handleDateChange = (dates: [Dayjs, Dayjs] | null) => {
  if (!dates || !dates[0] || !dates[1]) {
    emit("dateChange", "", "");
    return;
  }
  const [start, end] = dates;
  emit("dateChange", start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
};

const handleMobileDateChange = (dates: [Dayjs, Dayjs] | null) => {
  mobileDateRange.value = dates;
  isModalOpen.value = false;
  dateRange.value = dates;
  handleDateChange(dates);
};

const displayDateRange = computed(() => {
  if (!dateRange.value || !dateRange.value[0] || !dateRange.value[1]) {
    return (
      i18n.global.t("date.startDate") + " - " + i18n.global.t("date.endDate")
    );
  }
  const [start, end] = dateRange.value;
  return `${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`;
});

return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_range_picker, {
        value: dateRange.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
        locale: currentLocale.value,
        placeholder: [
          _unref(i18n).global.t('date.startDate'),
          _unref(i18n).global.t('date.endDate'),
        ],
        bordered: false,
        class: "w-full text-gray-700",
        onChange: handleDateChange
      }, null, 8, ["value", "locale", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (isModalOpen.value = true)),
        class: "w-full py-2 px-3 border rounded text-left bg-white shadow-sm text-gray-700"
      }, _toDisplayString(displayDateRange.value), 1)
    ]),
    _createVNode(_component_a_modal, {
      visible: isModalOpen.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((isModalOpen).value = $event)),
      title: "Chọn ngày",
      footer: null,
      closable: true,
      centered: "",
      "body-style": { padding: '16px' },
      width: "100vw",
      class: "custom-date-modal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_range_picker, {
          value: mobileDateRange.value,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((mobileDateRange).value = $event)),
          locale: currentLocale.value,
          class: "w-full",
          onChange: handleMobileDateChange
        }, null, 8, ["value", "locale"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})